import AlertError from "components/Alert/Error";
import { asMoney } from "utils/calcs";

interface FormOverLimitProps {
  overLimit: boolean;
  totalConsolidated: number;
  netLoanAmount: number;
}

const FormOverLimit = ({
  overLimit,
  totalConsolidated,
  netLoanAmount,
}: FormOverLimitProps) => {
  if (overLimit) {
    return (
      <AlertError title="Consolidated credit exceeds loan amount">
        <>
          <p>
            The total amount of £{asMoney(totalConsolidated, true)} exceeds the
            loan amount of £{asMoney(netLoanAmount, true)} by £
            {asMoney(totalConsolidated - netLoanAmount, true)}.
          </p>
          <p>Please adjust the consolidation amounts.</p>
        </>
      </AlertError>
    );
  }
  return <></>;
};

export default FormOverLimit;
